import React, { Suspense, useContext, useState } from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse"; // Assuming this is a layout component
import { Dropdown } from "react-bootstrap";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";
import { useMeal } from "contexts/v1/masterData/MealContext";
import Swal from "sweetalert2";
import { deleteRequest } from "services/api";

const MealPage = () => {
  const { meals, refetch, Pagination } = useMeal();
  console.log("MealPage", meals);
  const { handleSuccess, handleError, showCanvasHandler, handleSuccessToast } = useCanvasHandler();

  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Meal",
      <CreatePage onSuccess={
        () => {
          handleSuccessToast(true, "Meal created");
          refetch();
        }
      } onError={handleError} />
    );
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Meal",
      <CreatePage
        initialData={data}
        onSuccess={
          () => {
            handleSuccessToast(true, "Meal updated");
            refetch();
          }
        }
        onError={handleError}
      />
    );
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`/meal/${id}`);
    
        if (response.success) {
          handleSuccessToast(true, "Meal deleted");
          refetch();
        }
      }
    });
  };
  return (
    <LayoutDashboard>
      <div className="container-fluid mt-5">
        <div className="table-container vh-100">
          <div className="search-container mb-3">
            <SearchInput />

            <button className="btn btn-primary" onClick={handleCreate}>
              Create
            </button>
          </div>

          <div className="table table-responsive">
            <table className="table table-hover table-vcenter">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Name</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                {meals.data.map((data, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{data.name}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="secondary"
                          id="dropdown-basic"
                        >
                          Actions
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={(e) => handleUpdate(e, data)}
                          >
                            Update
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => handleDelete(data.id)}>
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4">{Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default MealPage;

// Search Input Component
const SearchInput = () => {
  const { handleSearch, filterOptions } = useMeal();
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24V0H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
